<template>
  <sui-page>
    <!-- Page Header -->
    <sui-page-header title="[Samples] Time Picker" />

    <!-- Page Contents -->
    <sui-page-contents>
      <!-- Time Picker [S] -->
      <div class="comm_view_wrap">
        <!-- (0) -->
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label label="<sui-time-picker>" />
          </div>
          <div class="col-xs-3">
            <sui-time-picker
              v-model="sampleValue0"
              :format="sampleFormat1"
              @confirm="onChangeSample0"
            />
          </div>
          <div class="col-xs-6">
            <span class="info">// empty</span>
            <span class="info caution">{{ JSON.stringify(sampleValue0) }}</span>
          </div>
        </div>

        <!-- (1) -->
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label label="<sui-time-picker>" />
          </div>
          <div class="col-xs-3">
            <sui-time-picker
              v-model="sampleValue1"
              :format="sampleFormat1"
              @confirm="onChangeSample1"
            />
          </div>
          <div class="col-xs-6">
            <span class="info">// with data (시:분)</span>
            <span class="info caution">{{ JSON.stringify(sampleValue1) }}</span>
          </div>
        </div>

        <!-- (2) -->
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label label="<sui-time-picker>" />
          </div>
          <div class="col-xs-3">
            <sui-time-picker
              v-model="sampleValue2"
              :format="sampleFormat2"
              @confirm="onChangeSample2"
            />
          </div>
          <div class="col-xs-6">
            <span class="info">// with data (시:분:초)</span>
            <span class="info caution">{{ JSON.stringify(sampleValue2) }}</span>
          </div>
        </div>

        <!-- (3) -->
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label label="<sui-time-picker>" />
          </div>
          <div class="col-xs-3">
            <sui-time-picker
              v-model="sampleValue2"
              disabled
              :format="sampleFormat2"
              @confirm="onChangeSample2"
            />
          </div>
          <div class="col-xs-6">
            <span class="info">// disabled (시:분:초)</span>
            <span class="info caution">{{ JSON.stringify(sampleValue2) }}</span>
          </div>
        </div>

        <!-- (4) -->
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label label="<sui-time-picker>" />
          </div>
          <div class="col-xs-3">
            <sui-time-picker
              v-model="sampleValue2"
              readonly
              :format="sampleFormat2"
              @confirm="onChangeSample2"
            />
          </div>
          <div class="col-xs-6">
            <span class="info">// readonly (시:분:초)</span>
            <span class="info caution">{{ JSON.stringify(sampleValue2) }}</span>
          </div>
        </div>

        <!--  -->
      </div>
      <!-- Time Picker [E] -->
    </sui-page-contents>
  </sui-page>
</template>

<script>
export default {
  name: 'CompGuideTimePicker',
  data() {
    return {
      // NOTE: 'HH'만 허용. 24시간제 TimePicker만 사용.
      sampleFormat1: 'HH:mm',
      sampleFormat2: 'HH:mm:ss',
      sampleValue0: {
        HH: '',
        mm: '',
      },
      sampleValue1: {
        HH: '14',
        mm: '25',
        ss: '36',
      },
      sampleValue2: {
        HH: '15',
        mm: '26',
        ss: '37',
      },
    };
  },
  computed: {},
  watch: {},
  datasets: [],
  mounted() {},
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {
    onChangeSample0(eventData) {
      console.log(`CompGuideTimePicker.onChangeSample0(): eventData = ${JSON.stringify(eventData)}`);
    },
    onChangeSample1(eventData) {
      console.log(`CompGuideTimePicker.onChangeSample1(): eventData = ${JSON.stringify(eventData)}`);
    },
    onChangeSample2(eventData) {
      console.log(`CompGuideTimePicker.onChangeSample2(): eventData = ${JSON.stringify(eventData)}`);
    },
  },
};
</script>

<style scoped>
</style>
